const styles={
    tRight:{
        textAlign:'right'
    },
    tCenter:{
        textAlign:'center'
    },
    pb10:{
        paddingBottom:'10px'
    },
    lineItem:{
        borderTop:'1px solid #ddd'
    },
    titleItem:{
        fontWeight:'400',marginBottom:'0px'
    },
    subTitleItem:{
        fontWeight:'300',color:'gray'
    },
    priceItem:{
        fontSize:'16px',textAlign:'right',height:'80px',lineHeight:'80px',verticalAlign:'middle'
    },
    mt10:{
        marginTop:'10px'
    },
    titleresumo:{
        color:'#565656'
    },
    resumdesc:{
        fontSize:'12px',marginTop:'30px',marginBottom:'5px',fontWeight:'400'
    },
    resumdesc2:{
        fontSize:'12px',marginTop:'0px',marginBottom:'5px',fontWeight:'400'
    },
    resumtotal:{
        fontSize:'15px',marginTop:'30px',marginBottom:'30px',fontWeight:'400'
    },
    valueResum:{
        width:'100px',textAlign:'right',fontSize:'16px',float:'right'
    },
    valueTotal:{
        width:'150px',textAlign:'right',fontSize:'20px',float:'right'
    }
};
  
export default styles;